import { render, staticRenderFns } from "./TurnaroundCreateModal.vue?vue&type=template&id=74ffb04a"
import script from "./TurnaroundCreateModal.vue?vue&type=script&lang=js"
export * from "./TurnaroundCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports